import {createContext} from 'react';

import {ClientContextProps} from 'pages/Client/types';

export const ClientContext = createContext<ClientContextProps>({} as ClientContextProps);
